import React from 'react';

const AIAssetInsight = ({ selectedAsset }) => {
  const score = typeof selectedAsset?.compositeScore === 'number' ? selectedAsset.compositeScore : null;
  const assetLabel = selectedAsset?.code || selectedAsset?.symbol || 'Actif';
  const momentum = selectedAsset?.momentumScore;
  const volatility = selectedAsset?.volatility;

  let insight = null;
  if (selectedAsset) {
    insight = (
      <div className="ai-asset-insight__panel">
        <div className="ai-asset-insight__asset">{assetLabel}</div>
        <div className="ai-asset-insight__body">
          {score !== null && score >= 80 ? (
            <>
              Cet actif présente un <b>score composite exceptionnel</b> ({score}). Le momentum reste élevé et la structure reste suffisamment propre pour justifier une surveillance renforcée.
            </>
          ) : score !== null && score >= 60 ? (
            <>
              Actif <b>au-dessus de la moyenne</b> ({score}). Le signal reste constructif, mais il faut surveiller de plus près la volatilité et l’essoufflement éventuel du flux.
            </>
          ) : (
            <>
              Score composite plus fragile ({score ?? '—'}). Le couple momentum / risque ne justifie pas encore une priorité élevée sans confirmation supplémentaire.
            </>
          )}
          <br />
          <br />
          <b>Lecture rapide :</b> momentum {momentum ?? '—'}, volatilité {volatility ?? '—'}, pattern {selectedAsset.detectedPattern ?? 'non détecté'}.
          <br />
          <i>Analyse IA simulée. Branchez un moteur d’interprétation dédié pour des commentaires plus avancés.</i>
        </div>
      </div>
    );
  }

  return (
    <div className="ai-asset-insight">
      <div className="ai-asset-insight__eyebrow">AI Asset Insight</div>
      <h3>Lecture synthétique</h3>
      <div className="ai-asset-insight__surface">
        {insight || (
          <div className="ai-asset-insight__placeholder">
            Sélectionnez un actif pour voir l'analyse IA.
          </div>
        )}
      </div>
    </div>
  );
};

export default AIAssetInsight;
